export default "__VITE_ASSET__b770f531__"